import { ApiInvite } from 'api/invite/types/ApiInvite';

// Types

export type MainStoreInvitesState = {
  byId: Record<string, ApiInvite & { isFetching: boolean }>;
};

export type FetchInviteRequestAction = {
  type: 'FETCH_INVITE_REQUEST';
  inviteId: string;
};

export type FetchInviteSuccessAction = {
  type: 'FETCH_INVITE_SUCCESS';
  invite: ApiInvite;
};

export type MainStoreInvitesAction =
  | FetchInviteRequestAction
  | FetchInviteSuccessAction;

// Reducer

export function invitesReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreInvitesState = {
    byId: {},
  },
  action: MainStoreInvitesAction,
) {
  switch (action.type) {
    case 'FETCH_INVITE_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.inviteId]: {
            ...state.byId[action.inviteId],
            id: action.inviteId,
            isFetching: true,
          },
        },
      };

    case 'FETCH_INVITE_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.invite.id]: { ...action.invite, isFetching: false },
        },
      };

    default:
      return state;
  }
}
